import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Form, Input } from 'antd'
import { get } from 'lodash-es'
import PropTypes from 'prop-types'

const TextArea = ({ name, label, ...rest }) => {
  const { control, errors } = useFormContext()
  const { message: errorMessage } = get(errors, name, {})

  return (
    <Form.Item
      label={label}
      help={errorMessage}
      validateStatus={errorMessage ? 'error' : 'success'}
    >
      <Controller control={control} name={name} as={Input.TextArea} {...rest} />
    </Form.Item>
  )
}

TextArea.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
}

TextArea.defaultProps = {
  label: '',
}

export default TextArea
